export default "__VITE_ASSET__DnP9ybIB__"